import { ExtendableError } from './extendableError.js';

export class NotFoundError extends ExtendableError {}
